import {Alert, Box, styled, Button, Tooltip} from '../../../ui-library';
import {tooltipClasses} from '@mui/material';
import React from 'react';


export const StatusAlert = styled(Alert)`
    margin-top: 30px;
    min-width: 900px;
`;


export const StartTrainingBtn = styled(Button)`
    font-size: 14px;
    line-height: 26px;
    height: 36px;
    width: 160px;
`;

export const FineTuneBtn = styled(Button)`
    font-size: 14px;
    line-height: 26px;
    height: 36px;
    width: 122px;
`;


export const statusChipsStyle = [
    {
        bgColor: ({ theme }: { theme: any }) => theme.palette.grey[200],
        textColor: ({ theme }: { theme: any }) => theme.palette.grey[500]
    },
    {
        bgColor: ({ theme }: { theme: any }) => theme.palette.primary.light,
        textColor: ({ theme }: { theme: any }) => theme.palette.primary.main
    },
    {
        bgColor: ({ theme }: { theme: any }) => theme.palette.success.light,
        textColor: ({ theme }: { theme: any }) => theme.palette.success.dark
    },
    {
        bgColor: ({ theme }: { theme: any }) => theme.palette.error.light,
        textColor: ({ theme }: { theme: any }) => theme.palette.error.dark
    }
];


export const BootstrapTooltip = styled(({ className, ...props }: any) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
        width: '206px',
        textAlign: 'center'
    },
}));


export const BinsBox = styled(Box)`
    margin-top: 46px;
    display: flex;
    flex-direction: row;
    gap: 32px;
    min-width: 900px;
`;


